import { userDate, OwaDate, addMinutes } from 'owa-datetime';
import { isFutureTime } from 'owa-observable-datetime';
import { ClientItem, SmartTimeSuggestion } from 'owa-mail-store';
import { trace } from 'owa-trace';
import { getConfiguredEventStartTimeEndTime } from 'owa-calendar-cloud-settings-utils';
import getDefaultEventDuration from 'owa-session-store/lib/selectors/getDefaultEventDuration';
import { OwaDateRange } from 'owa-datetime-utils/lib/OwaDateRange';

/**
 * Returns smart time suggested by the model if it's current to today's date.
 * Otherwise, use today's datetime to get the appropriate free times from CAS
 */
export default function getSmartTimeSuggestion(item: ClientItem): SmartTimeSuggestion {
    if (item?.SmartTimeExtendedProperty?.beginingOfTimeRange) {
        try {
            const startTime: OwaDate = userDate(item.SmartTimeExtendedProperty.beginingOfTimeRange);

            // Pass suggestions only when it is in the future
            if (isFutureTime(startTime)) {
                let duration: number = Number(item.SmartTimeExtendedProperty.duration);

                // if duration is null, "" or "0" use user default duration
                if (duration <= 0) {
                    duration = getDefaultEventDuration();
                }

                const endTime: OwaDate = addMinutes(startTime, duration);

                // Adjust startDate and endDate based on the shorten event duration setting
                const adjustedDateRange: OwaDateRange = getConfiguredEventStartTimeEndTime(
                    startTime,
                    endTime
                );

                return {
                    startTime: adjustedDateRange.start,
                    endTime: adjustedDateRange.end,
                };
            }
        } catch (error) {
            trace.warn(
                '[getSmartTimeSuggestion] Unable to parse suggested time. Error: ' + error.message
            );
            (error as { networkError?: boolean }).networkError = true;
            throw error;
        }
    }

    return null;
}
